import { Box } from '@mui/material';
import React, { useState } from 'react';
import TabPanel from '../Common/Layout/TabPanel';
import Payments from '@mui/icons-material/Payments';
import Storefront from '@mui/icons-material/Storefront';

import { useLocation } from 'react-router-dom';
import EtfList from './EtfList';
import EtfValuesList from './EtfValuesList';
import CustomAppBar from '../Common/Layout/CustomAppBar';

interface LocationState {
  indexOfActiveTab: number | null;
}

const EtfsInfoWrapper: React.FunctionComponent = () => {
  const location = useLocation();
  const locationState = location.state as LocationState | null;
  const indexOfActiveTab =
    locationState?.indexOfActiveTab != null ? locationState.indexOfActiveTab : 0;
  const [value, setValue] = useState<number>(indexOfActiveTab);
  return (
    <Box sx={{ width: '100%' }}>
      <CustomAppBar
        value={value}
        handleChange={(_, newValue) => setValue(newValue)}
        type="first"
        tabProps={[
          {
            id: 'etf',
            title: 'ETF',
            icon: Payments
          },
          {
            id: 'values',
            title: 'Values',
            icon: Storefront
          }
        ]}
      />
      <Box>
        <TabPanel value={value} index={0}>
          <EtfList indexOfActiveTab={value} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <EtfValuesList indexOfActiveTab={value} />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default EtfsInfoWrapper;
